import { frontendURL } from 'dashboard/helper/URLHelper.js';

import RemindersIndex from './Index.vue';

const remindersRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reminders'),
      name: 'reminders_index',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: RemindersIndex,
    },
  ],
};

export default remindersRoutes;
